
import axios from "axios";

// Production API URL (hosting domain)
// For shared hosting without mod_rewrite, use index.php in path
const PRODUCTION_API_URL = "https://handycraft.mitrajasabali.info/index.php/api";

// Use relative path for development, full URL for production
const API_BASE_URL = process.env.REACT_APP_API_URL || PRODUCTION_API_URL;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = {
      ...(config.headers || {}),
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    config.headers = {
      ...(config.headers || {}),
      Accept: "application/json",
    };
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (!window.location.pathname.startsWith("/login")) {
         window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const register = async (payload) => {
  const res = await apiClient.post("/register", payload);
  return res.data;
};

export const login = async (payload) => {
  const res = await apiClient.post("/login", payload);
  return res.data;
};

export const getProducts = async () => {
  const res = await apiClient.get("/products");
  return res.data;
};

export const getProduct = async (id) => {
  const res = await apiClient.get(`/products/${id}`);
  return res.data;
};

export const getCart = async () => {
  const res = await apiClient.get("/cart");
  return res.data;
};

export const addToCart = async (payload) => {
  const res = await apiClient.post("/cart", payload);
  return res.data;
};

export const removeCartItem = async (id) => {
  const res = await apiClient.delete(`/cart/${id}`);
  return res.data;
};

export const checkout = async (payload) => {
  const res = await apiClient.post("/checkout", payload);
  return res.data;
};

export const adminDashboard = async () => {
  const res = await apiClient.get("/admin/dashboard");
  return res.data;
};

export const adminOrders = async () => {
  const res = await apiClient.get("/admin/orders");
  return res.data;
};

export const adminUpdateOrderStatus = async (id, status) => {
  const res = await apiClient.post(`/admin/orders/${id}/status`, { status });
  return res.data;
};

export const adminCreateProduct = async (formData) => {
  const res = await apiClient.post("/admin/products", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const adminUpdateProduct = async (id, formData) => {
  const res = await apiClient.post(`/admin/products/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const adminDeleteProduct = async (id) => {
  const res = await apiClient.delete(`/admin/products/${id}`);
  return res.data;
};

// Sliders
export const getSliders = async () => {
  const res = await apiClient.get("/sliders");
  return res.data;
};

export const adminGetSliders = async () => {
  const res = await apiClient.get("/admin/sliders");
  return res.data;
};

export const adminCreateSlider = async (formData) => {
  const res = await apiClient.post("/admin/sliders", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const adminUpdateSlider = async (id, formData) => {
  const res = await apiClient.post(`/admin/sliders/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const adminDeleteSlider = async (id) => {
  const res = await apiClient.delete(`/admin/sliders/${id}`);
  return res.data;
};

// Settings
export const getSettings = async () => {
  const res = await apiClient.get("/settings");
  return res.data;
};

export const adminUpdateSettings = async (payload) => {
  const res = await apiClient.post("/admin/settings", payload);
  return res.data;
};

// User Orders
export const getMyOrders = async () => {
  const res = await apiClient.get("/my-orders");
  return res.data;
};

export const getMyOrderDetail = async (id) => {
  const res = await apiClient.get(`/my-orders/${id}`);
  return res.data;
};
